import useFetchAndTrace from "../../fetchWithTrace";
import { useCallback, useState } from "react";
import settings from "../../../../constants/settings";
import { useCustomAlert } from "../../alerts";
import { BoardDownloadFiles } from "../../../../reducers/uploadedBoard";

export default function useUpdateShoppingList(
  refreshBoardFiles: (boardFiles: BoardDownloadFiles) => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();
  const [updating, setUpdating] = useState(false);

  const errorHandler = useCallback(() => {
    setUpdating(false);
    customAlert("Failed to update part shopping list");
  }, [customAlert]);

  const getPartShoppingListHandler = useCallback(
    async (response: Response) => {
      setUpdating(false);
      if (response.ok) {
        const boardFilesResponse =
          (await response.json()) as BoardDownloadFiles;
        refreshBoardFiles(boardFilesResponse);
      } else {
        throw Error("Failed to get part shopping list");
      }
    },
    [refreshBoardFiles],
  );

  const updateShoppingList = useCallback(
    async (boardId: string) => {
      setUpdating(true);
      await fetchAndTrace(
        `${settings.api_url}/boards/${boardId}/part-shopping-list`,
        getPartShoppingListHandler,
        errorHandler,
      );
    },
    [errorHandler, fetchAndTrace, getPartShoppingListHandler],
  );

  return {
    updating,
    updateShoppingList,
  };
}
